import React from "react";

import DashboardLayout from "@/components/layout/DashboardLayout";
import Typography from "@/components/ui/typography";

import ApplicantsTable from "../components/ApplicantsTable";

const Applicants = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Typography size="h1">Applicants</Typography>
        </div>

        <ApplicantsTable />
      </div>
    </DashboardLayout>
  );
};

export default Applicants;
